import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

const StyledSteps = styled.ul`
  display: flex;
  justify-content: space-between;
  list-style: none;
  width: 100%;
  padding: 0;
  margin: 0;
  transform: translateY(-16px);
`;

export const ProgressSteps: React.FC<PropsWithChildren> = ({ children }) => {
  return <StyledSteps>{children}</StyledSteps>;
};
